export default __webpack_public_path__ + "static/media/SA.c46db873.jpg";